import { SearchResultIconColor } from '@/components/misc/GlobalSearch/types'

export const SEARCH_RESULT_ICON_COLORS: Record<
  SearchResultIconColor,
  SearchResultIconColor
> = {
  blue: 'blue',
  green: 'green',
  purple: 'purple',
}
